var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardCardNoteInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.9375C3.87598 0.9375 0.9375 3.87598 0.9375 7.5C0.9375 11.124 3.87598 14.0625 7.5 14.0625C11.124 14.0625 14.0625 11.124 14.0625 7.5C14.0625 3.87598 11.124 0.9375 7.5 0.9375ZM7.5 12.9492C4.49121 12.9492 2.05078 10.5088 2.05078 7.5C2.05078 4.49121 4.49121 2.05078 7.5 2.05078C10.5088 2.05078 12.9492 4.49121 12.9492 7.5C12.9492 10.5088 10.5088 12.9492 7.5 12.9492Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 4.92187C6.79688 5.10836 6.87095 5.2872 7.00282 5.41906C7.13468 5.55092 7.31352 5.625 7.5 5.625C7.68648 5.625 7.86532 5.55092 7.99718 5.41906C8.12905 5.2872 8.20312 5.10836 8.20312 4.92187C8.20312 4.73539 8.12905 4.55655 7.99718 4.42469C7.86532 4.29283 7.68648 4.21875 7.5 4.21875C7.31352 4.21875 7.13468 4.29283 7.00282 4.42469C6.87095 4.55655 6.79688 4.73539 6.79688 4.92187ZM7.85156 6.5625H7.14844C7.08398 6.5625 7.03125 6.61523 7.03125 6.67969V10.6641C7.03125 10.7285 7.08398 10.7812 7.14844 10.7812H7.85156C7.91602 10.7812 7.96875 10.7285 7.96875 10.6641V6.67969C7.96875 6.61523 7.91602 6.5625 7.85156 6.5625Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardNoteInfo);
export default __webpack_public_path__ + "static/media/DashboardCardNoteInfo.ad2e194de0b1ae05a7b0d23033100240.svg";
export { ForwardRef as ReactComponent };